import {
  hasAllowedPasswordCharacters,
  hasRequiredPasswordSpecialCharacter,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
} from '@/helpers/passwordValidation';

type Translate = (key: string) => string;

export const getBasePasswordError = (
  password: string,
  t: Translate,
): string | undefined => {
  if (!password) {
    return t('passwordRequired');
  }

  if (!hasAllowedPasswordCharacters(password)) {
    return t('passwordInvalidCharacters');
  }

  if (
    password.length < PASSWORD_MIN_LENGTH ||
    password.length > PASSWORD_MAX_LENGTH
  ) {
    return t('passwordLengthError');
  }

  return undefined;
};

export const getNewPasswordError = (
  password: string,
  t: Translate,
): string | undefined => {
  const basePasswordError = getBasePasswordError(password, t);

  if (basePasswordError) {
    return basePasswordError;
  }

  if (!/(?=.*[a-z])/g.test(password)) {
    return t('passwordAtLeastOneLowercase');
  }

  if (!/(?=.*[A-Z])/g.test(password)) {
    return t('passwordAtLeastOneUppercase');
  }

  if (!/(?=.*\d)/g.test(password)) {
    return t('passwordAtLeastOneDigit');
  }

  if (!hasRequiredPasswordSpecialCharacter(password)) {
    return t('passwordAtLeastOneSpecialChar');
  }

  return undefined;
};
